import { CompanyData } from 'User/types/user';

export const getCustomerFromCompanyData = (companyData: CompanyData): { customerId: string | null; customerName: string } => {
  const selectedId = companyData.selectedCompanyId;
  const effectiveId = selectedId ?? companyData.companies[0]?.id ?? null;
  const effectiveName = companyData.companies.find((c) => c.id === effectiveId)?.name ?? '';

  return { customerId: effectiveId, customerName: effectiveName };
};
